module.exports = __webpack_public_path__ + "img/bg-section-08.a747933c.svg";